module.exports = __webpack_public_path__ + "img/cashpay.44f36a28.png";